import { Link } from 'react-router';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 464px;
	width: 100%;

	@media (max-width: 992px) {
		max-width: 100%;
		text-align: center;
	}
`;

export const Title = styled.h1`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 32px;
		line-height: 1.32;
		text-align: center;
	}
`;

export const Description = styled.p`
	font-size: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	line-height: 32px;
	margin: 20px 0;
	max-width: 405px;

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const LinkStyled = styled(Link)`
	display: inline-flex;
	align-items: center;

	@media (max-width: 992px) {
		margin: 0 auto;
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	max-width: 545px;
	width: 100%;

	img {
		width: 100%;
		mix-blend-mode: lighten;
	}
`;
